import { render } from "./ScoutsLogo.vue?vue&type=template&id=68786bdc&scoped=true&ts=true"
import script from "./ScoutsLogo.vue?vue&type=script&lang=ts"
export * from "./ScoutsLogo.vue?vue&type=script&lang=ts"

import "./ScoutsLogo.vue?vue&type=style&index=0&id=68786bdc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68786bdc"]])

export default __exports__